import * as types from './mutations-types'

export default {
  [types.setInvoices] (state, invoices) {
    state.invoices = invoices
  },
  [types.setInvoice] (state, invoice) {
    state.invoice = invoice
  },
  [types.updateInvoicesList] (state, args) {
    state.invoices.splice(args.index, 1, args.invoice)
  },
  [types.setFilterInvoice] (state, obj) {
    state.filterInvoices[obj.key] = obj.value
  },
  [types.clearFilterInvoice] (state, key) {
    delete state.filterInvoices[key]
  },
  [types.clearFilterInvoices] (state) {
    state.filterInvoices = {}
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/invoices/vuex/mutations.js